import React from 'react';
import RegularHoursCandleNote from './RegularHoursCandleNote';

const CandleTrailDocs = (
    <>
        <p>
            Sets a candle trail on a position. If long, and the current price breaches
            the previous candle's low, or if short, and the current price breaches the
            previous candles high, we flatten the position.
        </p>
        params:
        <p>
            <b>candleDuration:</b>
            The duration of the candle you would like to track.
        </p>
        <p>
            <b>Use pre/postMarketData:</b>

            Let's say you have 5 minute candles, and you enter a position before the
            regular-session opening candle appears. If this is set to false, it will wait
            for that opening candle to complete before setting the trail. If it is true,
            it will use the last candle leading up to the regular-session open for the
            candle trail.
        </p>
        <p>
            <b>breakBy:</b>

            the amount the previous candle high/low needs to be broken by to close. If
            long and the previous candle low was 100, and this field is set to .1, it
            will wait till a break of 99.9 to flatten.
        </p>
        <p>NOTE:</p>
        <p>
            When we set the trail, we get both the current candle and the previous
            candle. If you are long and the current candle low is lower than the
            previous candle's low, or if you are short and the current candle high is
            higher than the previous candle's high, we use the current candle to set the
            trail.
        </p>
        {RegularHoursCandleNote}
    </>
);

export default CandleTrailDocs;
